import { useState } from 'react';
import { toggleDraftScope } from './mfsDraft.model';
import styles from './ScopeSelection.module.css';

function GroupCheck({ label, rows, draft, setDraft }) {
  const count = rows.filter(row => draft.componentIds.includes(row.key)).length;
  return <label className={styles.group}>
    <input type="checkbox" checked={rows.length > 0 && count === rows.length} disabled={!rows.length}
      ref={node => { if (node) node.indeterminate = count > 0 && count < rows.length; }}
      onChange={() => setDraft(previous => toggleDraftScope(previous, rows.map(row => row.key)))} />
    <strong>{label}</strong><span>{count}/{rows.length}</span>
  </label>;
}

export default function ScopeSelection({ catalog, draft, setDraft, initialSiteId, initialAssetId }) {
  const [query, setQuery] = useState('');
  const [limitToLocation, setLimitToLocation] = useState(Boolean(initialSiteId || initialAssetId));
  const visible = catalog.filter(row =>
    (!limitToLocation || ((!initialSiteId || row.siteId === initialSiteId) && (!initialAssetId || row.assetId === initialAssetId))) &&
    [row.siteLabel, row.assetLabel, row.code, row.name, row.subsystem].join(' ').toLowerCase().includes(query.toLowerCase().trim()));
  const sites = [...new Set(visible.map(row => row.siteId))];
  const missing = draft.componentIds.filter(id => !catalog.some(row => row.key === id));
  return <div className={styles.container}>
    <p>Select registered components across any number of locations. Group checkboxes affect the visible rows only; hidden selections remain.</p>
    <div className={styles.toolbar}>
      <label>Find location or component<input value={query} onChange={event => setQuery(event.target.value)} /></label>
      {(initialSiteId || initialAssetId) && <label className={styles.check}><input type="checkbox" checked={limitToLocation}
        onChange={event => setLimitToLocation(event.target.checked)} /> Limit list to the location used to open this draft</label>}
    </div>
    <div className={styles.summary}><strong>{draft.componentIds.length} selected · {visible.length} visible</strong>
      <button type="button" onClick={() => setDraft(previous => ({ ...previous, componentIds: [] }))}>Clear all selected components</button></div>
    {missing.length > 0 && <p className={styles.warning}>{missing.length} selected components are unavailable.
      {' '}<button type="button" onClick={() => setDraft(previous => ({
        ...previous,
        componentIds: previous.componentIds.filter(id => !missing.includes(id))
      }))}>Remove unavailable selections</button></p>}
    <div className={styles.tree}>
      {sites.map(siteId => {
        const children = visible.filter(row => row.siteId === siteId);
        return <section className={styles.site} key={siteId}>
          <GroupCheck label={children[0].siteLabel + ' — visible components'} rows={children} draft={draft} setDraft={setDraft} />
          {[...new Set(children.map(row => row.assetId))].map(assetId => {
            const rows = children.filter(row => row.assetId === assetId);
            return <div key={assetId} className={styles.asset}>
              <GroupCheck label={rows[0].assetLabel} rows={rows} draft={draft} setDraft={setDraft} />
              {rows.map(row => <label className={styles.leaf} key={row.key}>
                <input type="checkbox" checked={draft.componentIds.includes(row.key)}
                  onChange={() => setDraft(previous => toggleDraftScope(previous, [row.key]))} />
                <span><strong>{row.code}</strong> · {row.name}<small>{row.subsystem}</small></span>
              </label>)}
            </div>;
          })}
        </section>;
      })}
      {!visible.length && <p className={styles.empty}>No components match this view. Try clearing the search or location restriction.</p>}
    </div>
  </div>;
}